const providers = [
  {
    id: 'google',
    label: 'Fortsæt med Google',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
      </svg>
    ),
  },
  {
    id: 'apple',
    label: 'Fortsæt med Apple',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.7 9.05 7.42c1.32.07 2.23.72 3 .78 1.14-.19 2.23-.91 3.46-.82 1.47.13 2.57.7 3.3 1.73-3.02 1.84-2.3 5.88.5 7.02-.57 1.46-1.31 2.9-2.26 4.15zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
      </svg>
    ),
  },
  {
    id: 'microsoft',
    label: 'Fortsæt med Microsoft',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.4 2H2v9.4h9.4V2z" fill="#F25022"/>
        <path d="M22 2h-9.4v9.4H22V2z" fill="#7FBA00"/>
        <path d="M11.4 12.6H2V22h9.4v-9.4z" fill="#00A4EF"/>
        <path d="M22 12.6h-9.4V22H22v-9.4z" fill="#FFB900"/>
      </svg>
    ),
  },
];

export default function SocialButtons({ label = 'Eller log ind med' }) {
  return (
    <div className="social-section">
      <div className="divider">
        <span>{label}</span>
      </div>
      <div className="social-buttons">
        {providers.map((p) => (
          <button key={p.id} className="social-btn" type="button" onClick={() => alert(`${p.label} — ikke implementeret endnu`)}>
            {p.icon}
            <span>{p.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
